export default { 
    data: null,
    isSaved: false,
    validated: false
}